import { render, staticRenderFns } from "./PermissionConfigDialog.vue?vue&type=template&id=e58b5f72&scoped=true"
import script from "./PermissionConfigDialog.vue?vue&type=script&lang=js"
export * from "./PermissionConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./PermissionConfigDialog.vue?vue&type=style&index=0&id=e58b5f72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58b5f72",
  null
  
)

export default component.exports